const vars = {
	CONTENTFUL_SPACE_ID: "p3b01dlcg3rb",
	CLOUDINARY_UPLOAD_URL: "https://api.cloudinary.com/v1_1/dnbtaykkg/upload",
	CLOUDINARY_UPLOAD_PRESET: "irmw2xdz",
};

export default vars;


// WEBPACK FOOTER //
// ./src/vars.js